<div *ngIf="chartOptions">
    <highcharts-chart [Highcharts]="Highcharts"  [options]="chartOptions"></highcharts-chart>
</div>
